import React, { createContext, useContext, useReducer, useEffect, useState } from 'react';
import InitialStateService from '../services/InitialStateService';
import StationStateService from '../services/StationStateService';

// Define initial state and actions
const initialState = {
  adminUsers: [],
  loggedInViaLink:false,
  impersonatedUserId: "",
  showRegisterModal: false,
  userInfo: { userId: '', userName: '', role: 'Standard', isPublicViewer: false },
  hideHeader: false,
  hideHeaderButton: false,
  visaAktuell: false,
  loading: false,
  isAuthorized: false,
  showLoginModal: false,
  selectedDay: '',
  station: '---',
  selectedMonth: '',
  selectedMonthVacancy: '',
  heromaId: '',
  personalId: '',
  passtiderId: '',
  loadingArr: {},
  personChanged: false,
  selectedPersonalFile: '---',
  selectedPasstiderFile: '---',
  selectedHeromaFile: '---',
  htmlReportDone: false,
  monthReportDone: false,
  vacancyReportDone: false,
  hasPasstider: false,
  hasHeroma: false,
  stationAntalEnheter: '',
  stationAntalPersoner: '',
  monthlyReportNames: ['Underlag saknas'],
  monthlyVacancyReportNames: ['Underlag saknas'],
  dailyReportNames: ['Underlag saknas']
}

const SET_ADMIN_USERS = 'SET_ADMIN_USERS';
const SET_LOGGED_IN_VIA_LINK = 'SET_LOGGED_IN_VIA_LINK';
const SET_IMPERSONATED_USER_ID = 'SET_IMPERSONATED_USER_ID';
const SET_SHOW_REGISTER_MODAL = 'SET_SHOW_REGISTER_MODAL';
const SET_USER_INFO = 'SET_USER_INFO';
const SET_HIDE_HEADER = 'SET_HIDE_HEADER';
const SET_HIDE_HEADER_BUTTON = 'SET_HIDE_HEADER_BUTTON';
const SET_VISA_AKTUELL = 'SET_VISA_AKTUELL';
const SET_LOADING = 'SET_LOADING';
const SET_IS_AUTHORIZED = 'SET_IS_AUTHORIZED';
const SET_SHOW_LOGIN_MODAL = 'SET_SHOW_LOGIN_MODAL';
const SET_SELECTED_DAY = 'SET_SELECTED_DAY';
const SET_AREA_NAME = 'SET_AREA_NAME';
const SET_SELECTED_MONTH = 'SET_SELECTED_MONTH';
const SET_SELECTED_MONTH_VACANCY = 'SET_SELECTED_MONTH_VACANCY';
const SET_HEROMA_SCHEMA = 'SET_HEROMA_SCHEMA';
const SET_PERSONAL_ID = 'SET_PERSONAL_ID';
const SET_PASSTIDER = 'SET_PASSTIDER';
const SET_LOADING_ARR = 'SET_LOADING_ARR';
const SET_PERSON_CHANGED = 'SET_PERSON_CHANGED';

const SET_SELECTED_PERSONAL_FILE = 'SET_SELECTED_PERSONAL_FILE';
const SET_SELECTED_PASSTIDER_FILE = 'SET_SELECTED_PASSTIDER_FILE';
const SET_SELECTED_HEROMA_FILE = 'SET_SELECTED_HEROMA_FILE';
const SET_HTML_REPORT_DONE = 'SET_HTML_REPORT_DONE';
const SET_MONTH_REPORT_DONE = 'SET_MONTH_REPORT_DONE';
const SET_VACANCY_REPORT_DONE = 'SET_VACANCY_REPORT_DONE';
const SET_HAS_PASSTIDER = 'SET_HAS_PASSTIDER';
const SET_HAS_HEROMA = 'SET_HAS_HEROMA';

const SET_STATION_ANTAL_ENHETER = 'SET_STATION_ANTAL_ENHETER';
const SET_STATION_ANTAL_PERSONER = 'SET_STATION_ANTAL_PERSONER';

const SET_MONTHLY_REPORT_NAMES = 'SET_MONTHLY_REPORT_NAMES';
const SET_MONTHLY_VACANCY_REPORT_NAMES = 'SET_MONTHLY_VACANCY_REPORT_NAMES';
const SET_DAILY_REPORT_NAMES = 'SET_DAILY_REPORT_NAMES';

const LOAD_SAVED_STATE = 'LOAD_SAVED_STATE';
const LOAD_STATION_STATE = 'LOAD_STATION_STATE';

// Create the context and reducer
const GlobalStateContext = createContext();
const GlobalDispatchContext = createContext();

const globalReducer = (state, action) => {
  switch (action.type) {
    case SET_ADMIN_USERS:
      return { ...state, adminUsers: action.payload }
    case SET_LOGGED_IN_VIA_LINK:
      return { ...state, loggedInViaLink: action.payload }
    case SET_IMPERSONATED_USER_ID:
      return { ...state, impersonatedUserId: action.payload }
    case LOAD_SAVED_STATE:
      return { ...state, ...action.payload }
    case LOAD_STATION_STATE:
      return { ...state, ...action.payload }
    case SET_SHOW_REGISTER_MODAL:
      return { ...state, showRegisterModal: action.payload }
    case SET_USER_INFO:
      return { ...state, userInfo: action.payload }
    case SET_HIDE_HEADER:
      return { ...state, hideHeader: action.payload }
    case SET_HIDE_HEADER_BUTTON:
      return { ...state, hideHeaderButton: action.payload }
    case SET_VISA_AKTUELL:
      return { ...state, visaAktuell: action.payload }
    case SET_LOADING:
      return { ...state, loading: action.payload }
    case SET_IS_AUTHORIZED:
      return { ...state, isAuthorized: action.payload }
    case SET_SHOW_LOGIN_MODAL:
      return { ...state, showLoginModal: action.payload }
    case SET_SELECTED_DAY:
      return { ...state, selectedDay: action.payload }
    case SET_AREA_NAME:
      return { ...state, station: action.payload }
    case SET_SELECTED_MONTH:
      return { ...state, selectedMonth: action.payload }
    case SET_SELECTED_MONTH_VACANCY:
      return { ...state, selectedMonthVacancy: action.payload }
    case SET_PERSONAL_ID:
      return { ...state, personalId: action.payload }
    case SET_HEROMA_SCHEMA:
      return { ...state, heromaId: action.payload }
    case SET_PASSTIDER:
      return { ...state, passtiderId: action.payload }
    case SET_LOADING_ARR:
      return { ...state, loadingArr: action.payload }
    case SET_PERSON_CHANGED:
      return { ...state, personChanged: action.payload }
    case SET_SELECTED_PERSONAL_FILE:
      return { ...state, selectedPersonalFile: action.payload }
    case SET_SELECTED_PASSTIDER_FILE:
      return { ...state, selectedPasstiderFile: action.payload }
    case SET_SELECTED_HEROMA_FILE:
      return { ...state, selectedHeromaFile: action.payload }
    case SET_HTML_REPORT_DONE:
      return { ...state, htmlReportDone: action.payload }
    case SET_MONTH_REPORT_DONE:
      return { ...state, monthReportDone: action.payload }
    case SET_VACANCY_REPORT_DONE:
      return { ...state, vacancyReportDone: action.payload }
    case SET_HAS_PASSTIDER:
      return { ...state, hasPasstider: action.payload }
    case SET_HAS_HEROMA:
      return { ...state, hasHeroma: action.payload }
    case SET_STATION_ANTAL_ENHETER:
      return { ...state, stationAntalEnheter: action.payload }
    case SET_STATION_ANTAL_PERSONER:
      return { ...state, stationAntalPersoner: action.payload }
    case SET_MONTHLY_REPORT_NAMES:
      return { ...state, monthlyReportNames: action.payload }
    case SET_MONTHLY_VACANCY_REPORT_NAMES:
      return { ...state, monthlyVacancyReportNames: action.payload }
    case SET_DAILY_REPORT_NAMES:
      return { ...state, dailyReportNames: action.payload }
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
}

// Global provider component
export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);
  const [isStateLoaded, setIsStateLoaded] = useState(false);

  // Ladda sparat state från databasen vid mount
  useEffect(() => {
    const loadSavedState = async () => {
      // KRITISKT: Ladda bara om användaren är auktoriserad
      if (!state.isAuthorized) {
        return;
      }

      try {
        const savedState = await InitialStateService.getInitialState(state.impersonatedUserId);
        if (savedState) {
          dispatch({
            type: LOAD_SAVED_STATE,
            payload: {
              station: savedState.station || '---',
              hideHeader: savedState.hideHeader || false,
              hideHeaderButton: savedState.hideHeaderButton || false
            }
          });
        }
      } catch (error) {
        console.error('Error loading initial state:', error);
      } finally {
        setIsStateLoaded(true);
      }
    }

    loadSavedState();
  }, [state.impersonatedUserId, state.isAuthorized]);

  // Ladda senaste filer + antal enheter/personer för AKTUELL station.
  // Körs varje gång stationen byts, så värdena inte "läcker" mellan stationer
  // när samma användare hanterar flera stationer.
  useEffect(() => {
    const loadStationState = async () => {
      if (!state.isAuthorized || !state.station || state.station === '---') {
        dispatch({
          type: LOAD_STATION_STATE,
          payload: {
            selectedPersonalFile: '',
            personalId: '',
            selectedPasstiderFile: '',
            passtiderId: '',
            selectedHeromaFile: '',
            heromaId: '',
            stationAntalEnheter: '',
            stationAntalPersoner: ''
          }
        });
        return;
      }

      try {
        const stationState = await StationStateService.getState(state.station);
        dispatch({
          type: LOAD_STATION_STATE,
          payload: {
            selectedPersonalFile: stationState?.selectedPersonalFile || '',
            personalId: stationState?.personalId || '',
            selectedPasstiderFile: stationState?.selectedPasstiderFile || '',
            passtiderId: stationState?.passtiderId || '',
            selectedHeromaFile: stationState?.selectedHeromaFile || '',
            heromaId: stationState?.heromaId || '',
            stationAntalEnheter: stationState?.stationAntalEnheter || '',
            stationAntalPersoner: stationState?.stationAntalPersoner || ''
          }
        });
      } catch (error) {
        console.error('Error loading user station state:', error);
      }
    };

    loadStationState();
  }, [state.station, state.impersonatedUserId, state.isAuthorized]);

  return (
    <GlobalStateContext.Provider value={{ ...state, isStateLoaded }}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
}

// Custom hooks to use global state and dispatch
export const useGlobalState = () => useContext(GlobalStateContext);
export const useGlobalDispatch = () => useContext(GlobalDispatchContext);


// Custom hooks for specific state and dispatch actions
export const useLoggedInViaLink = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    loggedInViaLink: state.loggedInViaLink,
    setLoggedInViaLink: (value) => dispatch({ type: SET_LOGGED_IN_VIA_LINK, payload: value })
  }
}

export const useImpersonatedUserId = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    impersonatedUserId: state.impersonatedUserId,
    setImpersonatedUserId: (value) => dispatch({ type: SET_IMPERSONATED_USER_ID, payload: value })
  }
}

export const useAdminUsers = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    adminUsers: state.adminUsers,
    setAdminUsers: (value) => dispatch({ type: SET_ADMIN_USERS, payload: value })
  }
}

export const useShowRegisterModal = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    showRegisterModal: state.showRegisterModal,
    setShowRegisterModal: (value) => dispatch({ type: SET_SHOW_REGISTER_MODAL, payload: value })
  }
}

export const useHideHeaderButton = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    hideHeaderButton: state.hideHeaderButton,
    setHideHeaderButton: async (value) => {
      if (value === state.hideHeaderButton) return;
      // Uppdatera lokalt state först
      dispatch({ type: SET_HIDE_HEADER_BUTTON, payload: value });
      if (!state.isAuthorized) return;
      // Spara till databasen
      try {
        await InitialStateService.setDbState("hideHeaderButton", value ? "true" : "false", state.impersonatedUserId);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const useHideHeader = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    hideHeader: state.hideHeader,
    setHideHeader: async (value) => {
      if (value === state.hideHeader) return;
      // Uppdatera lokalt state först
      dispatch({ type: SET_HIDE_HEADER, payload: value });
      // Spara till databasen
      if (!state.isAuthorized) return;
      try {
        await InitialStateService.setDbState("hideHeader", value ? "true" : "false", state.impersonatedUserId);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const useVisaAktuell = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    visaAktuell: state.visaAktuell,
    setVisaAktuell: (value) => dispatch({ type: SET_VISA_AKTUELL, payload: value })
  }
}

export const useLoading = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    loading: state.loading,
    setLoading: (value) => dispatch({ type: SET_LOADING, payload: value })
  }
}

export const useShowLoginModal = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    showLoginModal: state.showLoginModal,
    setShowLoginModal: (value) => dispatch({ type: SET_SHOW_LOGIN_MODAL, payload: value })
  }
}

export const useIsAuthorized = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    isAuthorized: state.isAuthorized,
    setIsAuthorized: (value) => dispatch({ type: SET_IS_AUTHORIZED, payload: value })
  }
}

export const useUserInfo = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    userInfo: state.userInfo,
    setUserInfo: (value) => dispatch({ type: SET_USER_INFO, payload: value })
  }
}

export const useSelectedDay = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedDay: state.selectedDay,
    setSelectedDay: (value) => dispatch({ type: SET_SELECTED_DAY, payload: value })
  }
}

// Uppdaterad med database-integration
export const useStation = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    station: state.station,
    setStation: async (value) => {
      if (!state.isAuthorized || value === state.station) return;
      // Uppdatera lokalt state först
      dispatch({ type: SET_AREA_NAME, payload: value });
      // Spara till databasen
      try {
        await InitialStateService.setDbState("station", value, state.impersonatedUserId);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const useSelectedMonth = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedMonth: state.selectedMonth,
    setSelectedMonth: (value) => dispatch({ type: SET_SELECTED_MONTH, payload: value })
  }
}

export const useSelectedMonthVacancy = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedMonthVacancy: state.selectedMonthVacancy,
    setSelectedMonthVacancy: (value) => dispatch({ type: SET_SELECTED_MONTH_VACANCY, payload: value })
  }
}

export const useHeromaId = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    heromaId: state.heromaId,
    setHeromaId: async (value) => {
      if (!state.isAuthorized || value === state.heromaId) return;
      dispatch({ type: SET_HEROMA_SCHEMA, payload: value })
      try {
        await StationStateService.setDbState("heromaId", value, state.station);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const usePersonalId = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    personalId: state.personalId,
    setPersonalId: async (value) => {
      if (!state.isAuthorized || value === state.personalId) return;
      dispatch({ type: SET_PERSONAL_ID, payload: value })
      try {
        await StationStateService.setDbState("personalId", value, state.station);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const usePasstiderId = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    passtiderId: state.passtiderId,
    setPasstiderId: async (value) => {
      if (!state.isAuthorized || value === state.passtiderId) return;
      dispatch({ type: SET_PASSTIDER, payload: value })
      try {
        await StationStateService.setDbState("passtiderId", value, state.station);
      } catch (error) {
        console.error('Error saving area name to database:', error);
      }
    }
  }
}

export const useLoadingArr = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    loadingArr: state.loadingArr,
    setLoadingArr: (updater) => {
      const newValue = typeof updater === 'function'
        ? updater(state.loadingArr)
        : updater;

      dispatch({ type: SET_LOADING_ARR, payload: newValue });
    }
  }
}

export const usePersonChanged = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    personChanged: state.personChanged,
    setPersonChanged: (updater) => {
      const newValue = typeof updater === 'function'
        ? updater(state.personChanged)
        : updater;

      dispatch({ type: SET_PERSON_CHANGED, payload: newValue });
    }
  }
}

// Uppdaterad med database-integration
export const useSelectedPersonalFile = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedPersonalFile: state.selectedPersonalFile,
    setSelectedPersonalFile: async (value) => {
      if (!state.isAuthorized || value === state.selectedPersonalFile) return;
      dispatch({ type: SET_SELECTED_PERSONAL_FILE, payload: value });

      // Spara till databasen
      try {
        await StationStateService.setDbState("selectedPersonalFile", value, state.station);
      } catch (error) {
        console.error('Error saving personal file to database:', error);
      }
    }
  }
}

// Uppdaterad med database-integration
export const useSelectedPasstiderFile = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedPasstiderFile: state.selectedPasstiderFile,
    setSelectedPasstiderFile: async (value) => {
      if (!state.isAuthorized || value === state.selectedPasstiderFile) return;
      dispatch({ type: SET_SELECTED_PASSTIDER_FILE, payload: value });

      // Spara till databasen
      try {
        await StationStateService.setDbState("selectedPasstiderFile", value, state.station);
      } catch (error) {
        console.error('Error saving passtider file to database:', error);
      }
    }
  }
}

// Uppdaterad med database-integration
export const useSelectedHeromaFile = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    selectedHeromaFile: state.selectedHeromaFile,
    setSelectedHeromaFile: async (value) => {
      if (!state.isAuthorized || value === state.selectedHeromaFile) return;
      dispatch({ type: SET_SELECTED_HEROMA_FILE, payload: value });

      // Spara till databasen
      try {
        await StationStateService.setDbState("selectedHeromaFile", value, state.station);
      } catch (error) {
        console.error('Error saving heroma file to database:', error);
      }
    }
  }
}

export const useHtmlReportDone = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    htmlReportDone: state.htmlReportDone,
    setHtmlReportDone: (value) => dispatch({ type: SET_HTML_REPORT_DONE, payload: value })
  }
}

export const useMonthReportDone = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    monthReportDone: state.monthReportDone,
    setMonthReportDone: (value) => dispatch({ type: SET_MONTH_REPORT_DONE, payload: value })
  }
}

export const useVacancyReportDone = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    vacancyReportDone: state.vacancyReportDone,
    setVacancyReportDone: (value) => dispatch({ type: SET_VACANCY_REPORT_DONE, payload: value })
  }
}

export const useHasPasstider = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    hasPasstider: state.hasPasstider,
    setHasPasstider: (value) => dispatch({ type: SET_HAS_PASSTIDER, payload: value })
  }
}

export const useHasHeroma = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    hasHeroma: state.hasHeroma,
    setHasHeroma: (value) => dispatch({ type: SET_HAS_HEROMA, payload: value })
  }
}

export const useStationAntalEnheter = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    stationAntalEnheter: state.stationAntalEnheter,
    setStationAntalEnheter: async (value) => {
      if (!state.isAuthorized || value === state.stationAntalEnheter) return;
      dispatch({ type: SET_STATION_ANTAL_ENHETER, payload: value });

      // Spara till databasen
      try {
        await StationStateService.setDbState("stationAntalEnheter", value, state.station);
      } catch (error) {
        console.error('Error saving heroma file to database:', error);
      }
    }
  }
}

export const useStationAntalPersoner = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    stationAntalPersoner: state.stationAntalPersoner,
    setStationAntalPersoner: async (value) => {
      if (!state.isAuthorized || value === state.stationAntalPersoner) return;
      dispatch({ type: SET_STATION_ANTAL_PERSONER, payload: value });

      // Spara till databasen
      try {
        await StationStateService.setDbState("stationAntalPersoner", value, state.station);
      } catch (error) {
        console.error('Error saving heroma file to database:', error);
      }
    }
  }
}

export const useMonthlyReportNames = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    monthlyReportNames: state.monthlyReportNames,
    setMonthlyReportNames: (value) => dispatch({ type: SET_MONTHLY_REPORT_NAMES, payload: value })
  }
}

export const useMonthlyVacancyReportNames = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    monthlyVacancyReportNames: state.monthlyVacancyReportNames,
    setMonthlyVacancyReportNames: (value) => dispatch({ type: SET_MONTHLY_VACANCY_REPORT_NAMES, payload: value })
  }
}

export const useDailyReportNames = () => {
  const state = useGlobalState();
  const dispatch = useGlobalDispatch();

  return {
    dailyReportNames: state.dailyReportNames,
    setDailyReportNames: (value) => dispatch({ type: SET_DAILY_REPORT_NAMES, payload: value })
  }
}